module.exports = __webpack_public_path__ + "static/primary_logo-5408732f82f1adb8a4795095bdf9202d.png";